// extracted by mini-css-extract-plugin
export var active = "SidenavAccordion-module--active--1f375";
export var container = "SidenavAccordion-module--container--03e96";
export var isExpanded = "SidenavAccordion-module--isExpanded--8e40c";
export var section = "SidenavAccordion-module--section--82c19";
export var sectionContent = "SidenavAccordion-module--sectionContent--1e38f";
export var sectionTitle = "SidenavAccordion-module--sectionTitle--fd7d8";
export var sectionTitleIcon = "SidenavAccordion-module--sectionTitleIcon--af2b3";
export var sections = "SidenavAccordion-module--sections--a9667";